function shuffle(array) {
    let currentIndex = array.length;

    while (currentIndex !== 0) {
        let randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
}

const parent = document.getElementById('quotes');
const article = parent.querySelector('article');
const quotes = [...article.children];
shuffle(quotes);
article.innerHTML = '';
let fragment = document.createDocumentFragment();
const half = Math.ceil(quotes.length / 2);
for (let i = 0; i < half; i++) {
    fragment.appendChild(quotes[i]);
}
article.appendChild(fragment);

const second = document.createElement('article')
second.classList.add('quote-section', 'reverse');
for (let i = half; i < quotes.length; i++) {
    second.appendChild(quotes[i]);
}
parent.appendChild(second);